import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.angulartics2GoogleAnalytics.startTracking();
    this.titleService.setTitle(environment.title);
    this.metaService.addTag({name: 'og:type', content: 'article'});
    this.metaService.addTag({name: 'og:title', content: 'title'});
    this.metaService.addTag({name: 'og:description', content: 'description'});
    this.metaService.addTag({name: 'og:image', content: 'image'});
    this.metaService.addTag({name: 'og:url', content: 'url'});
    this.metaService.addTag({name: 'og:site_name', content: environment.companyName});
    this.metaService.addTag({name: 'twitter:title', content: 'title'});
    this.metaService.addTag({name: 'twitter:description', content: 'description'});
    this.metaService.addTag({name: 'twitter:image', content: 'image'});
    this.metaService.addTag({name: 'twitter:url', content: 'url'});
    this.metaService.addTag({name: 'twitter:site', content: `@${environment.twitterUsername}`});
    this.metaService.addTag({name: 'twitter:creator', content: `@${environment.twitterUsername}`});
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged(),
      )
      .subscribe((event: NavigationEnd) => {
         let route: ActivatedRoute = this.router.routerState.root;
          let routeData = null;
          let routeTitle = '';
          // tslint:disable-next-line:no-non-null-assertion
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data && route.snapshot.data['title']) {
            // tslint:disable-next-line:no-non-null-assertion
            routeTitle = route!.snapshot.data['title'];
            // tslint:disable-next-line:no-non-null-assertion
            routeData = route!.snapshot.data;
          }

          this.titleService.setTitle(`${routeData['title']} - ${environment.title}`);
          this.metaService.updateTag({name: 'og:type', content: (routeData['type'] ? routeData['type'] : 'website')});
          this.metaService.updateTag({name: 'og:site_name', content: environment.companyName});
          this.metaService.updateTag({name: 'og:url', content: `${environment.domain}${event.urlAfterRedirects}`});
          this.metaService.updateTag({name: 'twitter:url', content: `${environment.domain}${event.urlAfterRedirects}`});
          this.metaService.updateTag({name: 'twitter:site', content: `@${environment.twitterUsername}`});
          this.metaService.updateTag({name: 'twitter:creator', content: `@${environment.twitterUsername}`});
          this.metaService.updateTag({name: 'og:title', content: routeData['title']});
          this.metaService.updateTag({name: 'description', content: routeData['description']});
          this.metaService.updateTag({name: 'og:description', content: routeData['description']});
          this.metaService.updateTag({name: 'og:image', content: routeData['image']});
          this.metaService.updateTag({name: 'twitter:title', content: routeData['title']});
          this.metaService.updateTag({name: 'twitter:description', content: routeData['description']});
          this.metaService.updateTag({name: 'twitter:image', content: routeData['image']});
      });
  }

  getFullUrl(route: ActivatedRoute): string {
    let fullUrl = '';
    console.log(route);
    while (route.firstChild) {
      route = route.firstChild;
      const urlSegment = route.snapshot.url.map(segment => segment.path).join('/');
      fullUrl += `/${urlSegment}`;
      console.log(fullUrl);
    }

    return fullUrl;
  }

}
